import dynamic              from "next/dynamic";
import React, { useEffect } from "react";
import useSWRInfinite       from "swr/infinite";

import { useGetDeviceType }           from "_common/hooks/global";
import { formatPersonalizedFeedData } from "_common/utils/broadcast";
import { getPersonalizedFeedDataV2 }  from "_services/api/feed";

const MobileRecommendedVideos = dynamic ( () => import ( "./recommendedVideos" ) );
const ListWrapper             = dynamic ( () => import ( "./ListWrapper" ) );

const fetcher = async params => {
	const { pageNo } = params;

	const feedDataParams = {
		pageNo,
		pageSize   : 10,
		feedTypeId : 19
	};

	let result = await getPersonalizedFeedDataV2 ( feedDataParams );

	return formatPersonalizedFeedData ( result ) || [];
};

const component = props => {
	const { setPlaylist, playlist, from, customClass, currentVideoId } = props;

	const deviceType       = useGetDeviceType ();
	const isMobileOrTablet = deviceType === "mobile" || deviceType === "tablet";

	const { data, error, size, setSize } = useSWRInfinite (
		index => {
			return { key: `recommended-videos-list/${ currentVideoId }}`, pageNo: index + 1, pageSize: 10 };
		},
		fetcher
	);

	// state for infinite call logic
	let feedData               = [].concat.apply ( [], data );
	const isLoadingInitialData = !data && !error;
	const isEmpty              = data?.[size - 1]?.length === 0;
	const isLoadingMoreData    = isLoadingInitialData || ( size > 0 && data && typeof data[size - 1] === "undefined" );

	useEffect ( () => {
		if ( !data || !data.length )
			return;

		const filteredArr = feedData.filter ( v => {
			return v.id.toString () !== currentVideoId.toString ();
		} );

		const setData = new Set ( filteredArr );

		setPlaylist ( [ ...setData ] );
	}, [ data ] );

	// function to call API for next data in infinite call
	const getNextData = () => {
		setSize ( size + 1 );
	};

	if ( error )
		return null;

	if ( isMobileOrTablet ) {
		return (
			<MobileRecommendedVideos
				fetchMore  = { getNextData }
				isLoading  = { isLoadingInitialData || isLoadingMoreData }
				videosList = { playlist }
			/>
		);
	}

	return (
		<ListWrapper
			customClass    = { customClass }
			from           = { from }
			getNextData    = { getNextData }
			isDataDepleted = { isEmpty }
			isFetching     = { isLoadingInitialData }
			isFetchingData = { isLoadingMoreData }
			videosList     = { playlist }
		/>
	);
};

export default component;
